import { Navigate } from "react-router-dom";

const AddUser = () => <Navigate to="/investor" replace />;

export default AddUser;
